import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SaldeoHasloRequest, SaldeoLogowanie, SaldeoStatusResponse } from '../../shared/models/saldeo.model';

@Injectable({
    providedIn: 'root',
  })
  export class SaldeoService {

    constructor(
      private http: HttpClient,
    ) { }

    getUrlLogowanie(): Observable<SaldeoLogowanie> {
      return this.http.get<SaldeoLogowanie>('/api/klient/saldeo/logowanie');
    }

    getStatus(): Observable<SaldeoStatusResponse> {
      return this.http.get<SaldeoStatusResponse>('/api/klient/saldeo/status');
    }

    zapiszHaslo(request: SaldeoHasloRequest): Observable<void> {
      return this.http.post<void>('/api/klient/saldeo/haslo', request);
    }
}
